"use client";

export default function Value() {
  const steps = [
    {
      step: "STEP 1",
      description: "Register and attend for free",
    },
    {
      step: "STEP 2",
      description: " Dive into hands-on, practical learning",
    },
    {
      step: "STEP 3",
      description: "Walk away with real, actionable value",
    },
  ];

  return (
    <section className="w-full py-10 md:py-16">
      <div className="w-[90%] md:w-[80%] mx-auto">
        {/* Header Section */}
        <div className="mb-8 text-left">
          {/* <p className="text-[#0A0A0A] text-sm md:text-base font-normal uppercase mb-2">
            Copy Update:
          </p> */}
          <h2 className="text-[#002726] text-[28px] md:text-[32px] font-medium mb-3 ">
           A Workshop Worth Your Time. Guaranteed
          </h2>
          <p className="text-[#002726] text-base md:text-lg font-normal">
            No strings attached — just pure learning
          </p>
        </div>

        {/* Steps Section */}
        <div className="flex flex-col md:flex-row gap-4 md:gap-6 md:w-full">
          {steps.map((item, index) => (
            <div
              key={index}
              className="flex-1 rounded-xl p-4 border border-[#818490] text-left"
              style={{ backgroundColor: "#FFFAF1" }}
            >
              <h3 className="text-[#0A0A0A] text-sm font-normal mb-2">
                {item.step}
              </h3>
              <p className="text-[#002726] text-sm md:text-base font-normal">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
